import React from 'react'
import About from './About'

export default function ContentCard({content}) {
  return (
    <>
      <div className="contentcard">
        {content}
      </div>
    </>
  )
}

ContentCard.defaultProps = {
  con:<About/>
}